"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var client_1 = require("@apollo/client");
var Queries_1 = require("../Graphql/Queries");
var responseWithCsv_1 = require("../../../../lib/responseWithCsv");
var Spinner_1 = __importDefault(require("../../../../common/Spinner/Spinner"));
var DatePicker_1 = __importDefault(require("../../../../common/DatePicker/DatePicker"));
var general_1 = require("../../../../lib/general");
var Validate_1 = require("../Validate");
var Button_1 = __importDefault(require("../../../../common/Button/Button"));
var MonitoringHistoryReport = function () {
    var organization = (0, org_hook_1.useOrg)().organization;
    var _a = (0, react_1.useState)(new Date()), fromDate = _a[0], setFromDate = _a[1];
    var _b = (0, react_1.useState)(new Date()), toDate = _b[0], setToDate = _b[1];
    var _c = (0, react_1.useState)(false), displayFromCalender = _c[0], setDisplayFromCalender = _c[1];
    var _d = (0, react_1.useState)(false), displayToCalender = _d[0], setDisplayToCalender = _d[1];
    var _e = (0, react_1.useState)(null), error = _e[0], setError = _e[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var _f = (0, client_1.useLazyQuery)(Queries_1.MONITORING_HISTORY, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
        onCompleted: function (e) {
            var report = e ? e.generateMonitoringHistoryReport : "";
            var res = (0, responseWithCsv_1.reponseWithCsv)(report);
            if (res) {
                setFromDate(new Date());
                setToDate(new Date());
            }
        },
        onError: function (error) {
            console.log({ error: error });
        },
    }), generateMonitoringReport = _f[0], loading = _f[1].loading;
    var onClick = function () {
        var params = {
            to: (0, general_1.getDateFormat)(toDate),
            from: (0, general_1.getDateFormat)(fromDate),
            organization_id: organization.id,
            monitoring_category_id: 3,
        };
        var validateResponse = Validate_1.reportValidate.general(params);
        if (validateResponse.status === "success") {
            generateMonitoringReport({
                variables: params,
            });
        }
        else {
            setError(validateResponse);
        }
    };
    var commonChange = function () {
        setDisplayFromCalender(false);
        setDisplayToCalender(false);
        setError(null);
    };
    return (react_1.default.createElement("div", null,
        loading && react_1.default.createElement(Spinner_1.default, null),
        react_1.default.createElement(DatePicker_1.default, { error: error && error.field === "from" && error.message, title: "From Date", onClick: function () {
                setDisplayFromCalender(!displayFromCalender);
                setDisplayToCalender(false);
            }, onChange: function (date) {
                setFromDate(date);
                commonChange();
            }, value: fromDate, show: displayFromCalender }),
        react_1.default.createElement(DatePicker_1.default, { error: error && error.field === "to" && error.message, title: "To Date", onClick: function () {
                setDisplayToCalender(!displayToCalender);
                setDisplayFromCalender(false);
            }, onChange: function (date) {
                setToDate(date);
                commonChange();
            }, value: toDate, show: displayToCalender }),
        react_1.default.createElement(Button_1.default, { className: "form-buttom", text: t("Generate Report"), onClick: function () { return onClick(); } })));
};
exports.default = MonitoringHistoryReport;
